import { createContext, useContext, useState, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import themes from './index';
import CssVariableBridge from './CssVariableBridge';

const ThemeContext = createContext();

export function useThemeSwitch() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }) {
  const [themeKey, setThemeKey] = useState(() => {
    return localStorage.getItem('el-theme') || 'current';
  });

  const theme = useMemo(() => themes[themeKey] || themes.current, [themeKey]);

  const switchTheme = (key) => {
    if (themes[key]) {
      localStorage.setItem('el-theme', key);
      setThemeKey(key);
    }
  };

  const contextValue = useMemo(() => ({
    themeKey,
    switchTheme,
  }), [themeKey]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <CssVariableBridge />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
}
